import { ExpandMoreRounded } from '@mui/icons-material';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from '@mui/material';

function PanelSection({ label, children, ...props }) {
    return (
        <Accordion {...props}>
            <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                <Typography>{label}</Typography>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
}

export default PanelSection;
